<template>
  <!--  割引規則設定 -->
  <div class="form-module">
    <p class="module-title">{{ $locale("discountRules.setting") }}</p>
    <el-row :gutter="30">
      <el-col
        :span="3"
        v-for="item in formItems"
        :key="item.prop"
      >
        <el-form-item
          :label="item.formLabel"
          :prop="item.prop"
        >
          <el-select v-if="item.options" v-model="formObj[item.prop]" :disabled="item.disable">
            <el-option
              v-for="option in item.options"
              :label="option.label"
              :key="option.value"
              :value="option.value"
            />
          </el-select>
          <el-input v-model.number="formObj[item.prop]" @input="input_fn" v-else />
        </el-form-item>
      </el-col>
    </el-row>
    <!-- 本目の場合 -->
    <el-row
      v-for="(show, idx) in formObj.discountRules"
      :key="idx"
      :gutter="35"
    >
      <el-col :span="3">
        <span class="caseTitle">{{`${idx + 2}${$locale("discountRules.case")}`}}</span>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$locale('discountRules.free')">
          <el-select v-model="show.free">
            <el-option
              :label="$locale('global.yes')"
              :value="true"
            />
             <el-option
              :label="$locale('global.no')"
              :value="false"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="3">
        <el-form-item :label="$locale('discountRules.amount')">
          <el-input v-model.number="show.discountPrice" :disabled="show.free" />
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { discountSettingFormItems } from "@/assets/js/discountRuleTemplateDetail";
export default {
  name: "discountRuleTemplateDiscountSetting",
  data() {
    return {
      formItems: discountSettingFormItems,
    };
  },
  methods: {
    input_fn(value) {
      this.$emit("update", value);
    }
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
<style lang="less" scoped>
.form-module {
  .el-row {
    margin-bottom: 20px;
    .caseTitle {
      font-size: 16px;
      display: inline-block;
      margin-top: 40px;
    }
  }
}
  
</style>